export const UPDATE_SELECTED_CHAT_ID = 'UPDATE_SELECTED_CHAT_ID'

export interface UpdateSelectedChatIdAction {
    type: string
    chatUId: string
}
export const updateSelectedChatId = (chatUId: string): UpdateSelectedChatIdAction => ({
    type: UPDATE_SELECTED_CHAT_ID,
    chatUId
})
